<template>
  <img
    class="object-contain w-full h-10"
    alt="Swipe logo"
    src="@/assets/image/logo-swipe.svg"
  />
</template>
